import {
  Atom,
  Bot,
  Brain,
  Briefcase,
  Database,
  FileChartPie,
  FileDigit,
  FolderCode,
  Funnel,
  Lightbulb,
  type LucideProps,
  Microscope,
  PackageSearch,
  Sprout,
  SquarePercent,
  TrendingUp,
  Waypoints,
} from 'lucide-react';

type PositionIcon = React.ForwardRefExoticComponent<
  Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
>;

// Maps a position name to its lucide icon. Mirrors the legacy frontend mapping so
// the onboarding position list shows the same recognizable icons.
const positionIcons: Record<string, PositionIcon> = {
  'AI Engineer': Bot,
  'AI Research Scientist': Microscope,
  'Business Analyst': Briefcase,
  'Business Intelligence': Lightbulb,
  'Data Analyst': TrendingUp,
  'Data Engineer': Database,
  'Data Scientist': Atom,
  'Growth Marketer': Sprout,
  'Marketing Analyst': FileChartPie,
  'ML Engineer': Brain,
  'Pricing Analyst': SquarePercent,
  'Product Analyst': Funnel,
  'Product Manager': PackageSearch,
  'Quantitative Analyst': FileDigit,
  'Software Engineer': FolderCode,
  'Supply Chain Analyst': Waypoints,
};

// getPositionIconComponent returns the icon component for a position name,
// falling back to the Data Scientist icon for unknown names.
export function getPositionIconComponent(name: string): PositionIcon {
  return positionIcons[name] ?? Atom;
}
